import { Card, Text } from '@mantine/core';
import LineChart from './Charts/LineChart';
import PieChart from './Charts/PieChart';

const DashboardsCommon = ({ stats, chartTitle, subTitle, pieChartData, currency, lineStacked, expand, type }) => {
  const el =
    (stats || []).length === 0 && !pieChartData ? (
      <Card padding="md" radius="md" withBorder>
        <Text ta="center" fw={500}>
          No data available for the selected period
        </Text>
      </Card>
    ) : pieChartData ? (
      <LineChart
        stacked={lineStacked}
        data={stats}
        currency={currency}
        expand={expand}
        title={chartTitle}
        subTitle={subTitle}
        type={type}
      >
        <PieChart data={pieChartData} currency={currency} />
      </LineChart>
    ) : (
      <LineChart
        stacked={lineStacked}
        data={stats}
        currency={currency}
        title={chartTitle}
        expand={expand}
        subTitle={subTitle}
        type={type}
      />
    );

  return el;
};

export default DashboardsCommon;
